import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import User from '_class/User';
import { createMeeting, updateMeeting, clearMeeting, deleteMeetingRelationship, deleteMeeting, getMeeting, saveWizardMeeting, clearWizardMeeting } from 'actions/meetings';
import { getMeetingTimeBlocks } from 'actions/timeblocks';
import { setPageTitle } from 'actions/header';
import { Icon, Button, translate } from '@haldor/ui';
import Modal from 'containers/Modals/Modal';
import swal from 'sweetalert2';
import MeetingOccassions from 'containers/Meeting/Display/MeetingOccassions';
import CreateMeeting from 'containers/Meeting/Form/CreateMeeting';
import UpdateMeeting from 'containers/Meeting/Form/UpdateMeeting';
import ConnectForm from 'containers/Meeting/Form/ConnectForm';
import WizardStep from 'containers/Wizard/WizardStep';
import Wizard from 'containers/Wizard/Wizard';
import WizardQuestion from 'containers/Wizard/WizardQuestion';

var CreateMeetingWizard = /*#__PURE__*/function (_Component) {
  _inherits(CreateMeetingWizard, _Component);

  var _super = _createSuper(CreateMeetingWizard);

  function CreateMeetingWizard(props) {
    var _this;

    _classCallCheck(this, CreateMeetingWizard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.user);

      _this.props.setPageTitle(_this.props.translate('new-meeting'));

      if (!user.isMentor()) {
        window.location = '/meetings';
      }

      if (_this.props.meeting != null) {
        _this.props.clearMeeting();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearMeeting();

      _this.deleteMeeting();
    });

    _defineProperty(_assertThisInitialized(_this), "onCreateMeetingSubmit", function (meeting) {
      _this.setState({
        loading: true
      });

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.props.createMeeting(meeting);

                case 2:
                  _this.props.saveWizardMeeting(_this.props.meeting);

                  resolve(1);

                  _this.setState({
                    loading: false
                  });

                  _this.goToPage(_this.state.currentPage + 1);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateMeeting", function (values) {
      _this.setState({
        loading: true
      });

      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  values.id = _this.props.meeting.id;
                  values.instances = _this.props.meeting.instances;
                  _context2.next = 4;
                  return _this.props.updateMeeting(values);

                case 4:
                  _this.props.saveWizardMeeting(_this.props.meeting);

                  resolve(1);

                  _this.setState({
                    loading: false
                  });

                  _this.goToPage(_this.state.currentPage + 1);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "publishMeeting", function () {
      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
          var values;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(_this.props.meeting != null)) {
                    _context3.next = 6;
                    break;
                  }

                  values = _objectSpread({}, _this.props.meeting);
                  values.status = 'ACTIVE';
                  _context3.next = 5;
                  return _this.props.updateMeeting(values);

                case 5:
                  // Clear meeting wizard data here
                  resolve(1);

                case 6:
                  resolve(0);

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "deleteMeeting", function () {
      if (_this.props.meeting != null && !_this.state.submitting) {
        if (_this.props.meeting.status == "DRAFT") {
          _this.props.deleteMeeting(_this.props.meeting.id);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onConnectSubmit", function (submits) {
      _this.setState({
        loading: true
      });

      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
          var tasks;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  tasks = [];
                  submits.forEach(function (form) {
                    if (form.id == null) {
                      // Add form to meeting
                      var meeting = _objectSpread({}, _this.props.meeting);

                      if (meeting.meetingForms == null) {
                        meeting.meetingForms = [];
                      }

                      meeting.meetingForms.push(form);

                      var task = _this.props.updateMeeting(meeting);

                      tasks.push(task);
                    }
                  });
                  Promise.all(tasks).then(function () {
                    resolve(1);

                    _this.props.saveWizardMeeting(_this.props.meeting);

                    _this.toggleConnectForm(true);

                    _this.setState({
                      loading: false
                    });
                  });

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "goToPage", function (page) {
      if (_this.props.meeting != null && _this.state.loading == false) {
        _this.setState({
          currentPage: page
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "nextPage", function () {
      _this.goToPage(_this.state.currentPage + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleConnectForm", function () {
      var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (forceClose == true) {
        _this.setState({
          connectForm: false,
          activeForm: null
        });
      } else {
        _this.setState({
          connectForm: !_this.state.connectForm,
          activeForm: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "deleteForm", function (form) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(result) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    _this.props.deleteMeetingRelationship(_this.props.meeting.id, form.id).then(function () {
                      _this.props.getMeeting(_this.props.meeting.id).then(function () {
                        _this.setState({
                          loading: false
                        });
                      });

                      _this.props.addError(_this.props.translate('changes-saved'), 'info');
                    });
                  }

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref5.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "renderForms", function (targetedAudience) {
      var forms = _this.getForms();

      if (targetedAudience != null) {
        forms = forms.filter(function (t) {
          return targetedAudience.find(function (d) {
            return t.targetedAudience == d;
          }) != null;
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "meeting"
      }, /*#__PURE__*/React.createElement("div", {
        className: "forms"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          flex: 1
        }
      }, _this.props.translate('forms')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), forms != null ? forms.map(function (form) {
        if (targetedAudience != null) {
          if (targetedAudience.find(function (t) {
            return t == form.targetedAudience;
          }) == null) {
            return null;
          }
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "form",
          key: 'form-' + form.referenceID
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-title"
        }, /*#__PURE__*/React.createElement("div", null, form.reference.title), form.answeredBy == null ? /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            _this.deleteForm(form);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })) : null), /*#__PURE__*/React.createElement("div", {
          className: "size-14"
        }, _this.renderAudience(form.targetedAudience)));
      }) : null, forms != null && forms.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.25rem'
        }
      }, _this.props.translate('no-form')) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMeetingOccasions", function () {
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement(MeetingOccassions, {
        location: _this.props.location,
        next: _this.nextPage
      });
    });

    _this.state = {
      currentPage: 0,
      loading: false,
      connectForm: false,
      occassionsCreated: false,
      submitting: false
    };
    return _this;
  }

  _createClass(CreateMeetingWizard, [{
    key: "renderAudience",
    value: function renderAudience(audience) {
      if (audience == "STUDENT") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('assigned-to-students'));
      } else if (audience == "GUARDIAN") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('assigned-to-guardians'));
      } else if (audience == "SELF") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('assigned-to-me'));
      } else if (audience == "FOLLOWUP") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('follow-up'));
      } else {
        return /*#__PURE__*/React.createElement("span", null);
      }
    }
  }, {
    key: "getForms",
    value: function getForms() {
      var _this$props$meeting,
          _this2 = this;

      var forms = [];

      if (((_this$props$meeting = this.props.meeting) === null || _this$props$meeting === void 0 ? void 0 : _this$props$meeting.relationships) != null) {
        this.props.meeting.relationships.forEach(function (form) {
          if (form.referenceType == 'FORM') {
            _this2.props.meeting.instances.forEach(function (instance) {
              instance.relationships.forEach(function (relationship) {
                if (relationship.referenceType == "FORMINSTANCE") {
                  if (relationship.reference.formID == form.referenceID) {
                    form.answeredBy = form.answeredBy != null ? form.answeredBy++ : 1;
                  }
                }
              });
            });

            forms.push(form);
          }
        });
      }

      return forms;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _this$props$meeting2;

      var translate = this.props.translate;
      var forms = this.getForms();
      var isFollowUpAdded = false;
      forms.forEach(function (element) {
        if (element.targetedAudience === "FOLLOWUP") isFollowUpAdded = true;
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Wizard, {
        currentPage: this.state.currentPage,
        goToPage: function goToPage(i) {
          _this3.goToPage(i);
        }
      }, /*#__PURE__*/React.createElement(WizardStep, {
        name: translate('Meeting information')
      }, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          flex: 1
        }
      }, translate('Meeting information')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), this.props.meeting == null ? /*#__PURE__*/React.createElement(CreateMeeting, {
        onSubmit: this.onCreateMeetingSubmit
      }) : /*#__PURE__*/React.createElement(UpdateMeeting, {
        creating: true,
        onSubmit: this.onUpdateMeeting
      })), /*#__PURE__*/React.createElement(WizardStep, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Forms')), /*#__PURE__*/React.createElement(WizardQuestion, {
        text: translate('Would you like to send a questionnaire to participants before the meeting?'),
        buttons: [{
          onClick: function onClick() {
            _this3.goToPage(_this3.state.currentPage + 1);
          },
          value: translate('Yes'),
          type: 'primary'
        }, {
          onClick: function onClick() {
            _this3.goToPage(_this3.state.currentPage + 2);
          },
          value: translate('No'),
          type: 'secondary'
        }]
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: translate('Forms')
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.connectForm,
        onClose: this.toggleConnectForm,
        title: translate('add-form')
      }, /*#__PURE__*/React.createElement(ConnectForm, {
        onSubmit: this.onConnectSubmit,
        goToPage: function goToPage() {
          _this3.goToPage(_this3.state.currentPage + 1);
        },
        onClose: this.toggleConnectForm,
        isfollowUpAdded: isFollowUpAdded
      })), this.renderForms(), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleConnectForm
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('add-form')), /*#__PURE__*/React.createElement("div", {
        className: "float--right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.nextPage
      }, translate('Next')))), /*#__PURE__*/React.createElement(WizardStep, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Time slots')), /*#__PURE__*/React.createElement(WizardQuestion, {
        text: translate('Do you want to set up available time slots that guardians can book? The meeting invitation will be sent out when you publish the meeting.'),
        buttons: [{
          onClick: function onClick() {
            _this3.goToPage(_this3.state.currentPage + 1);
          },
          value: translate('Yes'),
          type: 'primary'
        }, {
          onClick: function onClick() {
            _this3.goToPage(_this3.state.currentPage + 2);
          },
          value: translate('No'),
          type: 'secondary'
        }]
      })), /*#__PURE__*/React.createElement(WizardStep, {
        name: translate('Time slots')
      }, this.renderMeetingOccasions()), /*#__PURE__*/React.createElement(WizardStep, {
        name: translate('Review and save')
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Review and save')), /*#__PURE__*/React.createElement(WizardQuestion, {
        text: translate('You can now either publish') + ' "' + ((_this$props$meeting2 = this.props.meeting) === null || _this$props$meeting2 === void 0 ? void 0 : _this$props$meeting2.title) + '" ' + translate('directly or save as draft and publish later.') + '<br /><br />' + translate('As long as the meeting is not published and has no booked meetings, you can edit meeting and rest lengths. When the meeting is published you can only change and remove slot series without booked meetings.'),
        buttons: [{
          onClick: function () {
            var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var _this3$props$meeting;

              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _this3.setState({
                        submitting: true
                      });

                    case 2:
                      _context6.next = 4;
                      return _this3.publishMeeting();

                    case 4:
                      _this3.props.clearWizardMeeting();

                      window.location = '/meeting/' + ((_this3$props$meeting = _this3.props.meeting) === null || _this3$props$meeting === void 0 ? void 0 : _this3$props$meeting.id);

                    case 6:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            function onClick() {
              return _onClick.apply(this, arguments);
            }

            return onClick;
          }(),
          isLoading: this.state.submitting,
          value: translate('Save and publish')
        }, {
          onClick: function () {
            var _onClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var tasks, _this3$props$meeting4;

              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return _this3.setState({
                        submitting: true
                      });

                    case 2:
                      if (_this3.props.meeting.id) {
                        tasks = [];
                        tasks.push(_this3.props.getMeetingTimeBlocks(_this3.props.meeting.id));
                        Promise.all(tasks).then(function () {
                          if (_this3.props.meetingTimeBlocks && _this3.props.meetingTimeBlocks.length > 0) {
                            var _this3$props$meeting2;

                            _this3.props.clearWizardMeeting();

                            window.location = '/meeting/' + ((_this3$props$meeting2 = _this3.props.meeting) === null || _this3$props$meeting2 === void 0 ? void 0 : _this3$props$meeting2.id) + "?onboarding=false#info";
                          } else {
                            var _this3$props$meeting3;

                            _this3.props.clearWizardMeeting();

                            window.location = '/meeting/' + ((_this3$props$meeting3 = _this3.props.meeting) === null || _this3$props$meeting3 === void 0 ? void 0 : _this3$props$meeting3.id) + "?onboarding=true#occasions";
                          }
                        });
                      } else {
                        _this3.props.clearWizardMeeting();

                        window.location = '/meeting/' + ((_this3$props$meeting4 = _this3.props.meeting) === null || _this3$props$meeting4 === void 0 ? void 0 : _this3$props$meeting4.id) + "?onboarding=true#occasions";
                      }

                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }));

            function onClick() {
              return _onClick2.apply(this, arguments);
            }

            return onClick;
          }(),
          value: translate('Save draft'),
          isLoading: this.state.submitting,
          type: 'secondary'
        }]
      }))));
    }
  }]);

  return CreateMeetingWizard;
}(Component);

function mapStateToProps(state) {
  var meeting = state.Meetings.meeting;

  if (meeting == null && state.Meetings.wizardMeeting != null) {
    meeting = state.Meetings.wizardMeeting;
  }

  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    meeting: meeting,
    meetingTimeBlocks: state.TimeBlocks.meetingTimeBlocks
  };
}

export default connect(mapStateToProps, {
  createMeeting: createMeeting,
  setPageTitle: setPageTitle,
  updateMeeting: updateMeeting,
  clearMeeting: clearMeeting,
  deleteMeetingRelationship: deleteMeetingRelationship,
  deleteMeeting: deleteMeeting,
  getMeeting: getMeeting,
  saveWizardMeeting: saveWizardMeeting,
  getMeetingTimeBlocks: getMeetingTimeBlocks,
  clearWizardMeeting: clearWizardMeeting
})(CreateMeetingWizard);